// abp-interceptor-patch.ts
import { HttpResponse } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';
import { SironaHttpInterceptor } from '@shared/common/http/sironaHttpInterceptor';
import { throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export function patchAbpInterceptor() {
  const proto = (SironaHttpInterceptor as any).prototype;
  const original = proto.handleErrorResponse;

  proto.handleErrorResponse = function (error: any) {
    if (!(error.error instanceof Blob)) {
      return original.call(this, error);
    }

    return this.configuration.blobToText(error.error).pipe(
      switchMap((text: string) => {
        let errorBody: any = {};
        try {
          if (text && text !== 'null') {
            errorBody = JSON.parse(text);
          }
        } catch {
          console.error('SironaHttpInterceptor: Could not parse the error blob (json expected)!');
          errorBody = {};
        }

        const errorResponse = new HttpResponse({
          headers: error.headers,
          status: error.status,
          body: errorBody
        });

        const ajaxResponse = this.configuration.getAbpAjaxResponseOrNull(errorResponse);
        if (ajaxResponse != null) {
          this.configuration.handleAbpResponse(errorResponse, ajaxResponse);
        } else {
          this.configuration.handleNonAbpErrorResponse(errorResponse);
        }

        return throwError(() => error);
      })
    );
  };
}
